import React from "react"
import PropTypes from "prop-types"
import {Provider} from "react-redux"
import {Route, BrowserRouter, Routes} from "react-router-dom"
import injectSheet from "react-jss"
import injectTexts from "./shared-components/styles/injectTexts"
import TextsProvider from "./shared-components/components/TextsProvider/textsProvider"
import MainLayoutContainer from "./layouts/mainLayout"
import StyleLoaderContainer from "./shared-components/components/StyleLoader/styleLoaderContainer"
import {AREA_TYPE} from "./constants/areaType"
import {getStyle, areCustomizedStyle} from "./store/selectors/localStorage/styleSelectors"
import {getTexts, isCustomizedTexts} from "./store/selectors/localStorage/textSelector"
import {getDynamicConfigurationValue} from "./store/selectors/localStorage/dynamicConfigurationSelectors"
import sheet from "./shared-components/styles/globalSheet"
import texts from "./styles/globalText"
import {AsyncTechnicalErrorScene} from "./layouts/asyncScenes"
import {Page} from "./constants/page/pages"
import {PagesArchitecture} from "./constants/page/pagesArchitecture"
import ErrorBoundaryContainer from "./shared-components/components/ErrorBoundary/errorBoundaryContainer"
import prestadomStyle from "./styles/prestadomStyle"
import {MatomoTracker} from "./shared-components/components/MatomoTracker/matomoTracker"
import {getCookiesChoices} from "./store/selectors/localStorage/cookiesSelectors"
import StyleLoaderLayout from "./layouts/styleLoaderLayout"
import NavigationInitializer from "./shared-components/services/navigate"

/**
 * Root of the application.
 * Set the provider to distribute the store in all components.
 * Set the router root.
 */
const Root = ({store, texts}) => (
    <Provider store={store}>
        <MatomoTracker getCookiesChoices={getCookiesChoices}>
            <TextsProvider texts={texts}>
                <BrowserRouter>
                    <NavigationInitializer />
                    <Routes>
                        <Route
                            element={AsyncTechnicalErrorScene}
                            path={PagesArchitecture[Page.TECHNICAL_ERROR].route}
                        />
                        <Route
                            element={
                                <StyleLoaderLayout>
                                    <MainLayoutContainer />
                                </StyleLoaderLayout>
                            }
                            path="/*"
                        />
                    </Routes>
                </BrowserRouter>
            </TextsProvider>
        </MatomoTracker>
    </Provider>
)

Root.propTypes = {
    store: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
}

export default injectTexts(texts, injectSheet(sheet, {inject: ["sheet"]})(Root))
